// Display helpers: units in a dimmer colour, and placeholder rows while something loads.

import { escHtml } from './toast';

/** A formatted figure as HTML with its unit dimmed: `+$1,234.50` keeps the sign bright, `48.5¢` dims the cent sign. */
export function unitHtml(text: string): string {
  const m = /^([+-]?)(\$)?(.*?)(¢|×)?$/.exec(text);
  if (!m || (!m[2] && !m[4])) return escHtml(text);
  return `${m[1]}${m[2] ? '<span class="u">$</span>' : ''}${escHtml(m[3])}${m[4] ? `<span class="u">${m[4]}</span>` : ''}`;
}

/** Shimmering placeholder lines, in place of "Loading…" text. */
export function skeletonHtml(rows = 3): string {
  return `<div class="skel-list">${Array.from({ length: rows }, (_, i) => `<div class="skel" style="width:${92 - (i % 3) * 18}%"></div>`).join('')}</div>`;
}
